import React from "react";

import FormTitle from "components/Form/Title";
import FormErrors from "pages/ApplicationForm/components/FormErrors";
import { isFormComplete } from "pages/ApplicationForm/formStatus";
import useApplicationStore from "store/Application";
import { StepProps } from "../../types";
import { STEPS } from "pages/ApplicationForm/formSteps";
import { FormSchemaStatus } from "pages/ApplicationForm/formSchema";
import { APPLICATION_IN_PROGRESS_KEY } from "utils/consts";

const STEP_KEY = "confirm";

const ReviewConfirmForm: React.FC<StepProps> = ({ errors }) => {
  const { formStatus } = useApplicationStore();

  const incompleteSteps = Object.values(STEPS).filter((step) => {
    const statusKey = step.key as keyof FormSchemaStatus;
    return (
      statusKey in formStatus &&
      formStatus[statusKey] === APPLICATION_IN_PROGRESS_KEY
    );
  });

  const applicationComplete = isFormComplete(formStatus);

  return (
    <div className="flex flex-col space-y-4">
      <FormTitle left border title="Review & Confirm" mb={false} />

      <FormErrors formErrors={errors?.[STEP_KEY]} />

      {!applicationComplete ? (
        <>
          <p className="pt-4">
            Please complete all form steps before submitting your Application.
            Incomplete steps:
          </p>
          <ul className="list-inside list-disc">
            {incompleteSteps.map((step) => (
              <li key={step.key}>{step.name}</li>
            ))}
          </ul>
        </>
      ) : (
        <>
          <span className="block text-base">
            Please ensure all information is accurate and complete. If
            everything is correct, click{" "}
            <span className="font-semibold">Submit Application</span> to
            proceed. To make changes, click{" "}
            <span className="font-semibold">Previous</span>.
          </span>
        </>
      )}
    </div>
  );
};

export default ReviewConfirmForm;
